import { ITranslationCountryType } from '../../utils/translation/types';
import styles from './styles.module.css';

interface SupportInfoProps {
  translate: ITranslationCountryType;
}

const SupportInfo = (props: SupportInfoProps) => {
  const { translate } = props;

  return (
    <div className={styles.supportInfo}>
      <div className={styles.footerLinks}>
        <div className={styles.supportLink}>
          <b className={styles.ajudaESuporte}>
            {translate['footer-help-support']}
          </b>
        </div>
        <div className={styles.policyLinks}>
          <div className={styles.polticaDePrivacidade}>
            {translate['footer-policy-delivery-time']}
          </div>
          <div className={styles.polticaDeTrocas}>
            {translate['footer-policy-exchange-refund']}
          </div>
        </div>
      </div>

      <img
        className={styles.gfgHorizontalPositive}
        loading="lazy"
        alt=""
        src="/gfg--horizontal--positive.svg"
      />

      <div className={styles.contactInfo}>
        <b className={styles.centralDeAtendimento}>
          {translate['footer-call-center']}
        </b>
        <div className={styles.atendimentoCallContainer}>
          {translate['footer-service-url'] ? (
            <a
              href={translate['footer-service-url']}
              target="_blank"
              rel="noopener noreferrer"
            >
              {translate['footer-service-number']}
            </a>
          ) : (
            <span>{translate['footer-service-number']}</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default SupportInfo;
